import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "utterance-list" }
const _hoisted_2 = { class: "utterance-list-item add-item-wrapper" }
const _hoisted_3 = {
  key: 0,
  class: "help is-danger"
}
const _hoisted_4 = ["disabled"]

import { UtteranceViewModel } from '@/features/bots/models/intents/utteranceViewModel';
import { nanoid } from 'nanoid';
import { computed, nextTick, onMounted, PropType, ref } from 'vue';
import { useVModel } from '@vueuse/core';
import useVuelidate from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import UtteranceListItem from './UtteranceListItem.vue';
import VuelidateUtil from '@shared/util/vuelidateUtil';


export default /*@__PURE__*/_defineComponent({
  __name: 'UtteranceList',
  props: {
  modelValue: {
    type: Array as PropType<UtteranceViewModel[]>,
    required: true,
  },
  term: {
    type: String,
    default: 'utterance',
  },
  isEditable: {
    type: Boolean,
    default: false,
  },
},
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

const utterances = useVModel(props, 'modelValue', emit);
const utteranceItems = ref<InstanceType<typeof UtteranceListItem>[]>([]);

const validations = {
  utterances: {
    required,
  },
};

const $v = useVuelidate(validations, { utterances });
const isUtteranceRequiredInvalid = computed(() => VuelidateUtil.isRequiredInvalid($v, 'utterances'));

onMounted(() => {
  if ($v.value.$reset) {
    $v.value.$reset();
  }

  if (utterances.value.length === 0) {
    addUtterance();
  }
});

function addUtterance() {
  const utteranceId = nanoid(7);
  utterances.value.push({
    id: utteranceId,
    text: '',
  });
  focusOnUtterance(utteranceId);
}

function deleteUtterance(id: string) {
  $v.value.$touch();
  utterances.value = utterances.value.filter((u) => u.id !== id);
}

function moveToNextUtterance(fromUtteranceId: string) {
  const currentIndex = utterances.value.findIndex((u) => u.id === fromUtteranceId);
  const nextIndex = currentIndex + 1;
  if (nextIndex >= utterances.value.length) {
    addUtterance();
  } else {
    const nextUtteranceId = utterances.value[nextIndex].id;
    focusOnUtterance(nextUtteranceId);
  }
}

function focusOnUtterance(utteranceId: string) {
  nextTick(() => {
    const index = utterances.value.findIndex((u) => u.id === utteranceId);
    if (utteranceItems.value[index]) {
      utteranceItems.value[index].focus();
    }
  });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
    _createVNode(_TransitionGroup, { name: "fade" }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(utterances), (utterance) => {
          return (_openBlock(), _createBlock(UtteranceListItem, {
            key: utterance.id,
            utterance: _unref(utterances)[_unref(utterances).indexOf(utterance)],
            "onUpdate:utterance": ($event: any) => ((_unref(utterances)[_unref(utterances).indexOf(utterance)]) = $event),
            "all-utterances": _unref(utterances),
            term: __props.term,
            "is-editable": __props.isEditable,
            onDelete: deleteUtterance,
            onMoveToNext: moveToNextUtterance,
            ref_for: true,
            ref_key: "utteranceItems",
            ref: utteranceItems
          }, null, 8, ["utterance", "onUpdate:utterance", "all-utterances", "term", "is-editable"]))
        }), 128))
      ]),
      _: 1
    }),
    _createElementVNode("li", _hoisted_2, [
      (isUtteranceRequiredInvalid.value)
        ? (_openBlock(), _createElementBlock("p", _hoisted_3, "You must add at least one " + _toDisplayString(__props.term), 1))
        : _createCommentVNode("", true),
      _createElementVNode("button", {
        class: "button is-primary is-outlined is-fullwidth add-utterance",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (addUtterance())),
        disabled: !__props.isEditable
      }, " Add Another Example ", 8, _hoisted_4)
    ])
  ]))
}
}

})